import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=cb048388&scoped=true&"
import script from "./EmptyContent.vue?vue&type=script&lang=js&"
export * from "./EmptyContent.vue?vue&type=script&lang=js&"
import style0 from "./EmptyContent.vue?vue&type=style&index=0&id=cb048388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb048388",
  null
  
)

export default component.exports